export default __webpack_public_path__ + "static/media/dashboard-sidebar-icon.c96fa9d9.svg";